import React from 'react';
import { number, oneOfType, string } from 'prop-types';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';
import { isEmpty } from '../../../../../../../core/util/empty';

// @ts-expect-error ts-migrate(2417) FIXME: Type '{ deductibleAmountIndividualInNetwork: Valid... Remove this comment to see the full error message
class DeductibleIndividualNonZero extends Base {
  static propTypes = {
    deductibleAmountIndividualInNetwork: oneOfType([number, string]).isRequired,
  };

  static isVisible = ({ deductibleAmountIndividualInNetwork }: any) =>
    !isEmpty(deductibleAmountIndividualInNetwork) &&
    parseInt(deductibleAmountIndividualInNetwork, 10) > 0;

  icon = '/images/insurance_tutorial/06_individual_deductible.svg';

  render = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'deductibleAmountIndividualInNetwork' doe... Remove this comment to see the full error message
    const { deductibleAmountIndividualInNetwork } = this.props;
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>Your deductible, explained</H2>

            <P>
              First up: your deductible&mdash;the amount you'll pay for covered services before your
              insurance starts to chip in.
            </P>

            <P>
              Your annual individual in-network deductible is{' '}
              <b>${deductibleAmountIndividualInNetwork}</b>. You'll pay full price for most care
              until you reach this amount&mdash;unless it's preventative care which is typically
              covered fully.
            </P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default DeductibleIndividualNonZero;
